<template>
    <section class="about-ad content-section" ref="ad" id="ad">
        <b-container>
            <b-row>
                <b-col lg="12">
                    <h2 class="title">WE ARE THE SPECIALISTS WHO CARE ABOUT<br />OUR CLIENTS AND PRODUCTS</h2>
                    <hr>
                </b-col>
                <b-col 
                    lg="4"
                    v-for="(info,i) in infos"
                    :key="i"
                >
                    <transition name="fade">
                    <div class="ad-item-wrap" :class="info.icon" v-if="show[i]">
                        <h3>{{info.title}}</h3>
                        <ul>
                            <li v-for="(detail, i) in info.details" :key="i">{{detail}}</li>
                        </ul>
                    </div>
                    </transition>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
export default {
    data() {
        return {
            show: [false, false, false],
            infos: [
                {
                    icon: 'pro',
                    title: 'PROFESSIONAL TEAM',
                    details: ['Prompt Service', 'On Time Delivery', 'Competitive Pricing']
                },
                {
                    icon: 'exc',
                    title: 'EXCLUSIVE TECHNOLOGY',
                    details: ['Customized Services', 'Low cost but High Quality Materials', 'Experienced Engineers']
                },
                {
                    icon: 'sup',
                    title: 'SUPERIOR QUALITY',
                    details: ['Strict Quality Control Standard', 'Professional Inspectors', 'Ensure the Perfection Before Delivery']
                }
            ]
        }
    },
    watch: {
        show(v) {
            if(v.reduce((a,b) => a && b)){
                window.removeEventListener('scroll', this.scrollHandle)
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollHandle);
    },
    methods: {
        scrollHandle(e) {
            let { top } = this.$refs.ad.getBoundingClientRect()
            if(top < 360) {
                let dur = 0
                this.show.forEach((element, idx) => {
                    setTimeout(() => {
                        this.$set(this.show, idx, true)
                    }, dur += 400);
                });
            }
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollHandle)
    },
}
</script>

<style lang="scss">
    .about-ad{
        color: #fff;
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-image: url("~@/assets/images/about/reason_bg.jpg");

        .title{
            text-align: center;
            font-size: 36px !important;
            border-bottom-color: rgba(255,255,255,1);
            color: $color-main;
            letter-spacing: 2px;
            text-shadow: 1px 1px#fff,-1px 1px#fff,-1px -1px#fff,1px -1px#fff;
        }

        hr{
            margin: 50px 0;
            background-color: #fff;
        }

        .ad-item-wrap{
            padding-left: 50px;
            background: no-repeat 0 0;
            background-size: 40px;

            ul li{
                list-style-position: inside;
                list-style-type: square;
            }

            &.pro{background-image: url('~@/assets/images/about/icon_01.png');}
            &.exc{background-image: url('~@/assets/images/about/icon_02.png');}
            &.sup{background-image: url('~@/assets/images/about/icon_03.png');}
        }
    }
</style>